import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../../common/CCUtils"

export enum VaporAssets {
    DOG = "VaporDOG",
    BABY_CRIB = "VaporBABY_CRIB",

    ROOM = "VaporROOM",
    VAPE_CLOUD = "VaporVAPE_CLOUD",
    VAPOR_PUDDLE = "VaporVAPOR_PUDDLE",

    INTRO = "VaporINTRO",
    CLICK_BABY = "VaporCLICK_BABY",
    BABY_COUGH = "VaporBABY_COUGH",
}

export function loadAssets(game: Phaser.Game) {
    game.load.spritesheet(VaporAssets.DOG, CCUtils.asset("second-hand/effects-of-vapor/dog-sprite.png"), 220, 122)
    game.load.spritesheet(VaporAssets.BABY_CRIB, CCUtils.asset("second-hand/effects-of-vapor/baby-crib-cough.png"), 564, 260)

    game.load.image(VaporAssets.ROOM, CCUtils.asset("second-hand/effects-of-vapor/vapor-room.png"))
    game.load.image(VaporAssets.VAPE_CLOUD, CCUtils.asset("second-hand/effects-of-vapor/vape-cloud.png"))
    game.load.image(VaporAssets.VAPOR_PUDDLE, CCUtils.asset("second-hand/effects-of-vapor/vapor-puddle.png"))

    game.load.audio(VaporAssets.INTRO, CCUtils.asset("second-hand/effects-of-vapor/audio/sh-vapor-intro.mp3"))
    game.load.audio(VaporAssets.CLICK_BABY, CCUtils.asset("second-hand/effects-of-vapor/audio/click-on-baby.mp3"))
    game.load.audio(VaporAssets.BABY_COUGH, CCUtils.asset("second-hand/effects-of-vapor/audio/baby-cough.mp3"))
}
